import React from "react";
import { OrganizationEditFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import address from "utils/jsons/thailandAddress/address.json";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const OrganizationEditForm = ({ onSubmit, initialValues }) => {
  const schema = yup.object().shape({
    phone_number: yup.string().required("Phone number is required"),
    email: yup.string().email().required("Email is required"),
    province: yup.object().nullable().required("Province is required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      phone_number: initialValues?.phone_number || "",
      email: initialValues?.email || "",
      province: initialValues?.province
        ? { label: initialValues.province, value: initialValues.province }
        : null,
    },
  });

  const { t } = useTranslation(["common", "register", "profile"]);

  const renderProvinceOptions = () => {
    return address.reduce((result, data, i) => {
      if (i === 0) {
        result.push({ label: data.province, value: data.province });
      } else {
        let find = result.find((e) => e.value === data.province);
        if (!find) {
          result.push({ label: data.province, value: data.province });
        }
      }
      return result;
    }, []);
  };

  return (
    <OrganizationEditFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={t("Mobile number", { ns: "register" })}
                placeholder={t("Mobile number", { ns: "register" })}
                errors={errors.phone_number?.message}
              />
            )}
            name="phone_number"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                label={t("Email", { ns: "register" })}
                placeholder={t("Email", { ns: "register" })}
                errors={errors.email?.message}
              />
            )}
            name="email"
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DropdownSelect
                {...field}
                options={renderProvinceOptions()}
                label={t("Address", { ns: "profile" })}
                placeholder={`* ${t("Province", { ns: "register" })}`}
                errors={errors.province?.message}
              />
            )}
            name="province"
          />
        </div>
        <Buttons.BgStandard
          type="submit"
          label={t("Edit", { ns: "common" })}
        />
      </form>
    </OrganizationEditFormStyled>
  );
};

OrganizationEditForm.propTypes = {};

export default OrganizationEditForm;
